import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, switchMap, take } from 'rxjs';
import { AuthenticationManager } from './authentication-manager';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CallApiService {

    private readonly baseUrl = environment.apiCallUrl;

    constructor(
        private http: HttpClient,
        private auth: AuthenticationManager
    ) {}

    get<T>(path: string): Observable<T> {
        return this.withAuthHeaders().pipe(
            switchMap(headers => this.http.get<T>(`${this.baseUrl}${path}`, { headers }))
        );
    }

    post<T>(path: string, body: any = null): Observable<T> {
        return this.withAuthHeaders().pipe(
            switchMap(headers => this.http.post<T>(`${this.baseUrl}${path}`, body, { headers }))
        );
    }

    put<T>(path: string, body: any = null): Observable<T> {
        return this.withAuthHeaders().pipe(
            switchMap(headers => this.http.put<T>(`${this.baseUrl}${path}`, body, { headers }))
        );
    }

    delete<T>(path: string): Observable<T> {
        return this.withAuthHeaders().pipe(
            switchMap(headers => this.http.delete<T>(`${this.baseUrl}${path}`, { headers }))
        );
    }

    private withAuthHeaders(): Observable<HttpHeaders> {
        return this.auth.getAccessToken().pipe(
            take(1),
            switchMap(token => {
                if (!token) {
                    throw new Error('No access token available');
                }
                return [new HttpHeaders().set('Authorization', `Bearer ${token}`)];
            })
        );
    }
}
